import React from "react";
import { Mail } from "lucide-react";

export default function PrivacyPolicyAppendix() {
  return (
    <>
      <section data-testid="privacy-instagram">
        <h2 className="text-2xl font-semibold text-white mb-4">Instagram data and deletion</h2>
        <p className="text-zinc-300 leading-relaxed">
          The site owner uses GP App to schedule and publish posts to his own Instagram professional account through Meta&apos;s official API. The integration stores the account token, account ID, username, and basic information about the owner&apos;s posts. It does not collect visitor or other Instagram users&apos; data. This information is deleted within 30 days after disconnection or a deletion request. Request deletion at{" "}
          <a href="https://giopilos.com/deletion" className="text-emerald-400 hover:text-emerald-300">giopilos.com/deletion</a>{" "}
          or remove the app under Instagram Settings &gt; Apps and websites.
        </p>
      </section>
      <section data-testid="privacy-contact">
        <h2 className="text-2xl font-semibold text-white mb-4">Privacy contact</h2>
        <div className="backdrop-blur-xl bg-purple-900/20 border border-white/10 rounded-lg p-6">
          <p className="text-zinc-300 mb-4">For privacy questions or requests, contact:</p>
          <a href="mailto:privacy@giopilos.com" className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 transition font-semibold">
            <Mail size={18} /> privacy@giopilos.com
          </a>
          <p className="text-zinc-500 text-sm mt-4">Requests are answered within 30 days.</p>
        </div>
      </section>
    </>
  );
}